import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlignmentService {
  constructor() {
  }

  public MainWindow?: HTMLElement;
}
